<template>
	<div class="d3-generic-reading" :class="cssClass">
		<div class="axis" ref="axis"></div>
		<div class="pin min">
			<span class="value">{{ min }} <span v-html="units"></span></span>
			<span class="line"></span>
			<span class="label">Min</span>
		</div>
		<div class="pin avg">
			<span class="value">{{ avg }} <span v-html="units"></span></span>
			<span class="line"></span>
			<span class="label">Average</span>
		</div>
		<!--div class="pin std-dev">
			<span class="value">{{ std_dev }} <span v-html="units"></span></span>
			<span class="line"></span>
			<span class="label">Standard deviation</span>
		</div-->
		<div class="pin max">
			<span class="value">{{ max }} <span v-html="units"></span></span>
			<span class="line"></span>
			<span class="label">Max</span>
		</div>
	</div>
</template>

<script>
import * as d3 from '@/utils/d3'
export default {
	props: [
		'type',
		'reading',
		'min',
		'max',
		'avg',
		'std_dev',
		'units'
	],
	data () {
		return {
			width: 0,
			height: 0,
			pinOffset: 6, // 12px wide
		}
	},
	computed: {
		scale () {
			const min = Math.min(this.min, this.avg, this.std_dev, this.max)
			const max = Math.max(this.min, this.avg, this.std_dev, this.max)
			return d3.scaleLinear()
				.domain([min, max])
				.range([0, this.width])
		},
		readingId () {
			return this.reading.id
		},
		cssClass () {
			return 'd3-generic-reading-' + this.type
		}
	},
	methods: {
		onResize () {
			this.width = Math.max(this.$refs.axis.offsetWidth, 0)
			this.height = Math.max(this.$refs.axis.offsetHeight, 0)
			this.update()
		},
		update () {
			d3.select(`.${this.cssClass} .min`)
				.style('left', `${this.scale(this.min) - this.pinOffset}px`);

			d3.select(`.${this.cssClass} .avg`)
				.style('left', `${this.scale(this.avg) - this.pinOffset}px`);

			d3.select(`.${this.cssClass} .std-dev`)
				.style('left', `${this.scale(this.std_dev) - this.pinOffset}px`);

			d3.select(`.${this.cssClass} .max`)
				.style('left', `${this.scale(this.max) - this.pinOffset}px`);
		}
	},
	mounted () {
		window.addEventListener('resize', this.onResize)
		this.onResize()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onResize)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometricD3.vue